import React, { FC } from 'react'

import { IconChevronFilledDown, IconChevronFilledUp } from '@avantstay/backoffice-vectors'

import { SortingDirection } from '../../../hooks'
import * as S from './SortColumnIndicator.styles'

interface SortColumnIndicatorProps {
  sorting?: SortingDirection
  onSort: (sort: SortingDirection) => void
}

export const SortColumnIndicator: FC<SortColumnIndicatorProps> = ({ sorting, onSort }) => (
  <S.IndicatorContainer>
    <S.IconWrapper active={sorting === SortingDirection.Asc}>
      <IconChevronFilledUp onClick={() => onSort(SortingDirection.Asc)} />
    </S.IconWrapper>
    <S.IconWrapper active={sorting === SortingDirection.Desc}>
      <IconChevronFilledDown onClick={() => onSort(SortingDirection.Desc)} />
    </S.IconWrapper>
  </S.IndicatorContainer>
)
